<section class="section-pd list-wrapper-style-2 gcWithoutInternet">
    <div class="trinka_container container">
        <div class="row justify-content-center">
            <div class="col-md-11 col-lg-11">
                <div class="trinka-title mb-0 text-center">
                    <h2>離線也能檢查文法，守護資料零風險</h2>
                    <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    <p>Trinka 為企業推出 Windows 桌面應用程式，即使在無網路環境下，也能進行 AI 驅動的文法校對，完整保護資料隱私。</p>
                </div>
            </div>
        </div>
        <app-offline-key-features></app-offline-key-features>
        <div class="row">
            <div class="col-12">
                <div class="complianceBox">
                    <div class="trinka-title text-center">
                        <h3>您的資料，只留在您的電腦裡</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <button (click)="navigationService.goToEnterpriseForm()" class="filled-btn nowrap" type="button" *ngIf="!modalButton">欲知更多詳情</button>
                        <button class="filled-btn sensitive-btn" type="button" (click)="triggerScroll()" *ngIf="sensitiveButton">欲知更多詳情</button>
                        <a [routerLink]="['/windows-desktop-app']" class="outline-btn"  *ngIf="!windowsButton">歡迎與我們聯繫</a>
                        <!-- <a [routerLink]="['/windows-desktop-app/offline-grammar-checker']" class="outline-btn offlineBtn" *ngIf="windowsButton">歡迎與我們聯繫</a> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>